<template>
  <collapsible-card
    id="layout-revisions"
    title="Revisions"
    state-key="revisions">
    <div
      v-for="revision in shortRevisionList"
      :key="revision.id"
      class="row"
      @click="selectRevision(revision)"
    >
      <div
        :class="{'published-revision': activeRevisionId === revision.id}"
        class="col-12 pointer"
      >
        {{ revision.created_at }}
        {{ revision.created_by ? revision.created_by.username : '' }}
      </div>
    </div>

    <a
      href="#"
      @click="showRevisionsModal = true">View all revisions ({{ $store.state.layout.totalCount }})
    </a>

    <div v-if="showRevisionsModal">
      <modal :close="() => showRevisionsModal = false">
        <div slot="header">Revisions</div>
        <div slot="body">
          <div
            v-for="revision in revisions"
            :key="revision.id"
            class="row"
            @click="selectRevision(revision)"
          >
            <div
              :class="{'published-revision': activeRevisionId === revision.id}"
              class="col-12 pointer"
            >
              {{ revision.created_at }}
              {{ revision.created_by ? revision.created_by.username : '' }}
            </div>
          </div>
        </div>

        <div slot="footer">
          <table>
            <pagination
              :page-selected="revisionLayoutSelected"
              :state="$store.state.layout"/>
          </table>
        </div>
      </modal>
    </div>
  </collapsible-card>
</template>

<script>
import Modal from '@/components/Modal'
import Pagination from '@/components/Pagination'
import CollapsibleCard from '../../page/components/CollapsibleCard'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'Revisions',
  components: {
    CollapsibleCard,
    Modal,
    Pagination
  },
  data: () => ({
    showRevisionsModal: false
  }),
  computed: {
    ...mapGetters({
      revisions: 'layout/revisions',
      newLayout: 'layout/newLayout',
      shortRevisionList: 'layout/shortRevisionList',
      activeRevisionId: 'layout/activeRevisionId'
    })
  },
  methods: {
    ...mapMutations('layout', {
      selectRevision: 'SELECT_REVISION'
    }),
    ...mapActions('layout', ['getRevisionsByLayoutId']),
    revisionLayoutSelected (pageId) {
      this.getRevisionsByLayoutId({ id: this.newLayout.id, page: pageId })
    }
  }
}
</script>

<style>
.published-revision {
  background-color: #4ab2e3;
  color: #fff;
}

.modal-footer .btn {
  margin: 0;
}

#layout-revisions .h4 {
  text-align: end;
}

.pointer {
  cursor: pointer;
}
</style>
